// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import translate from "@insite/client-framework/Translate";
import { DealerModel } from "@insite/client-framework/Types/ApiModels";
import Modal, { ModalPresentationProps, ModalProps } from "@insite/mobius/Modal";
import ContactUsForm from "@keller/App/Components/ContactUs/ContactUsForm";
import React, { FC, useEffect, useState } from "react";

export interface ContactUsLocationModalState {
    location?: LocationModel | DealerModel;
}

interface OwnProps extends ModalProps {
    location?: LocationModel | DealerModel;
    handleClose?: () => void;
}

type Props = OwnProps;

interface ContactUsFormModalStyles {
    modal?: ModalPresentationProps;
}

const contactUsFormModalStyles: ContactUsFormModalStyles = {};

const styles = contactUsFormModalStyles;

const ContactUsFormModal: FC<Props> = ({ location, handleClose }) => {
    const [isOpen, setIsOpen] = useState(!!location);

    useEffect(() => {
        setIsOpen(!!location);
    }, [location]);

    const onSuccessSubmit = () => {
        handleClose?.();
    };

    return (
        <Modal headline={translate("Get in touch")} {...styles.modal} isOpen={isOpen} handleClose={handleClose} size={700}>
            <ContactUsForm location={location} onSuccessSubmit={onSuccessSubmit} />
        </Modal>
    );
};

export default ContactUsFormModal;
